import Nullstack from 'nullstack';
export default function IconGenderBigender({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-gender-bigender",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "11",
    cy: "11",
    r: "4"
  }), "   ", Nullstack.element("path", {
    d: "M19 3l-5 5"
  }), "   ", Nullstack.element("path", {
    d: "M15 3h4v4"
  }), "   ", Nullstack.element("path", {
    d: "M11 16v6"
  }), "   ", Nullstack.element("path", {
    d: "M8 19h6"
  }), " ");
}